import * as React from "react";

import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Home from "../Pages/Home/Home";
// import CaseStudies from '../Pages/CaseStudies';
import CaseStudiesDetail from "../Pages/Home/CaseStudiesDetail";
import NewsInsights from "../Pages/NewsPage/NewsInsights";
import CaseStudies from "../Pages/CaseStudiePage/CaseStudies";
import NewsInsightsDetail from "../Pages/NewsPage/NewsInsightsDetail";
import TermsConditions from "../Pages/TermsConditions";
import PrivacyPolicy from "../Pages/PrivacyPolicy";
import AboutUs from "../Pages/About/AboutUs";
import IndustriesDetails from "../Pages/Industries/IndustriesDetails";
import ServicesDetails from "../Pages/Services/ServicesDetails";

export default function IndexRoutes() {
  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/home" element={<Home />} />
      <Route path="/case-studies" element={<CaseStudies />} />
      <Route path="/case-studies-detail" element={<CaseStudiesDetail />} />
      <Route path="/news-insights" element={<NewsInsights />} />
      <Route
        path="/news-insights-detail/:slug"
        element={<NewsInsightsDetail />}
      />
      <Route path="/terms-conditions" element={<TermsConditions />} />
      <Route path="/privacy-policy" element={<PrivacyPolicy />} />
      <Route path="/about" element={<AboutUs />} />
      <Route path="/industries/:slug" element={<IndustriesDetails />} />
      <Route path="/services/:slug" element={<ServicesDetails />} />
    </Routes>
  );
}
